<div>
    <mat-form-field style="min-width: 300px; width: 100%" [attr.data-cy]="'ccaca_mat-form-field_1_8_'">
        <input
            matInput
            [matAutocomplete]="autoClient"
            [formControl]="clientFormCtrl"
            [placeholder]="placeholder"
            [required]="required"
            [attr.data-cy]="'ccaca_input_1_1_'"
        />
        <button
            *ngIf="showClear"
            [disabled]="disabled"
            matSuffix
            mat-icon-button
            color="accent"
            (click)="clear()"
            [attr.data-cy]="'ccaca_button_1_0_'"
        >
            <mat-icon [attr.data-cy]="'ccaca_mat-icon_1_2_'">cancel</mat-icon>
        </button>
        <mat-autocomplete
            #autoClient="matAutocomplete"
            [displayWith]="clientMapper"
            (optionSelected)="autocompleteClientSelected($event)"
            [panelWidth]="panelWidth"
        >
            <mat-option [attr.data-cy]="'ccaca_mat-option_1_7_'">Kein Betrieb</mat-option>
            <mat-option
                *ngFor="let c of clients | async; let i = index"
                [value]="c"
                [attr.data-cy]="'ccaca_mat-option_2_7_' + i"
            >
                <div style="width: 100%; border-bottom: 1px solid #ccc; padding: 5px">
                    <span style="padding: 5px" [attr.data-cy]="'ccaca_span_1_16_' + i">{{ getBezeichnung(c) }}</span>
                </div>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-checkbox
        *ngIf="showInactiveToggle"
        [(ngModel)]="includeInactive"
        (change)="inaktiveAnzeigen($event)"
    >
        Inaktive Betriebe anzeigen
    </mat-checkbox>
</div>
